import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Admin from './Admin';
import BandLanding from './BandLanding';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<BandLanding />} />
        <Route path="/shorturl" element={<App />} />
        <Route path="/shorturl/admin" element={<Admin />} />
      </Routes>
    </Router>
  </React.StrictMode>
); 